import { useCallback, useEffect, useState } from "react"

import {
  getDistribuitorProviderDailyAvailable,
  getProviderDetail,
  getProviders,
  postDistribuitorProviderDaily,
  putDistribuitorProviderDaily,
} from "helpers/backend_helper"

import useAvailabilityBoard from "common/availability/hooks/useAvailabilityBoard"

/**
 * Alta de disponibilidad desde el portal del distribuidor: añade al núcleo
 * compartido el selector de proveedor y los endpoints `/distribuitor/*`.
 */
export default function useAvailabilityCreate() {
  const [providers, setProviders] = useState([])
  const [providerId, setProviderId] = useState(null)

  const load = useCallback(async () => {
    const [disponibilidad, detalle] = await Promise.all([
      getDistribuitorProviderDailyAvailable(providerId),
      getProviderDetail(providerId),
    ])
    return {
      dates: disponibilidad?.dates || [],
      dailies: disponibilidad?.data || [],
      farms: detalle?.farms || [],
    }
  }, [providerId])

  const create = useCallback(
    (registro, { date }) =>
      postDistribuitorProviderDaily({ providerId, date, data: [registro] }),
    [providerId]
  )

  const update = useCallback(
    (registro, { date }) =>
      putDistribuitorProviderDaily({
        providerId,
        date,
        daily_availability_id: registro.id,
        data: [registro],
      }),
    [providerId]
  )

  const board = useAvailabilityBoard({
    load,
    create,
    update,
    ready: !!providerId,
  })

  const { setIsLoading, clearSelection } = board

  useEffect(() => {
    const cargarProveedores = async () => {
      try {
        const response = await getProviders()
        setProviders(response || [])
        // sin proveedores no hay nada que cargar: se apaga el spinner aquí
        if (response && response.length) setProviderId(response[0].id)
        else setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
      }
    }
    cargarProveedores()
    // eslint-disable-next-line
  }, [])

  const onChangeProvider = value => {
    setProviderId(value)
    clearSelection()
  }

  return {
    state: { ...board.state, providers, providerId },
    events: { ...board.events, onChangeProvider },
  }
}
